export const CREDIT_API_URL = process.env.REACT_APP_CREDIT_SERVICE_API_BASE_URL
export const TRUSTPAISA_URL = process.env.REACT_APP_TRUSTPAISA_URL
export const CASHE_URL = process.env.REACT_APP_CASHE_URL
export const DWINGER_AGENTS_URL = process.env.REACT_APP_DWINGER_AGENTS_URL
export const FI_URL = process.env.REACT_APP_FI_URL

